import * as types from 'store/modules/hrmsLov/mutation-types'
import hrmsLov from 'api/hrmsLov'
import swal from 'sweetalert'
import hrmsLovLabels from 'assets/labels/hrmsLov'
import { hrmsLovColumns } from 'assets/columns/hrmsLov'
import configLabel from 'src/../config/label'
import env from 'src/../env.js'

export default {
  state: {
    popupLov: {
      codempid: { total: 0, rows: [], loading: false, finish: false },
      codemp9: { total: 0, rows: [], loading: false, finish: false },
      codpos: { total: 0, rows: [], loading: false, finish: false },
      codapp: { total: 0, rows: [], loading: false, finish: false },
      nummemo: { total: 0, rows: [], loading: false, finish: false },
      codcours: { total: 0, rows: [], loading: false, finish: false },
      codform: { total: 0, rows: [], loading: false, finish: false },
      numappl: { total: 0, rows: [], loading: false, finish: false },
      numreq: { total: 0, rows: [], loading: false, finish: false },
      codaplvl: { total: 0, rows: [], loading: false, finish: false },
      grdscor: { total: 0, rows: [], loading: false, finish: false },
      grditem: { total: 0, rows: [], loading: false, finish: false },
      codappr: { total: 0, rows: [], loading: false, finish: false },
      codshift: { total: 0, rows: [], loading: false, finish: false },
      codroom: { total: 0, rows: [], loading: false, finish: false },
      codasset: { total: 0, rows: [], loading: false, finish: false },
      codcalen: { total: 0, rows: [], loading: false, finish: false },
      codcompy: { total: 0, rows: [], loading: false, finish: false },
      batchno: { total: 0, rows: [], loading: false, finish: false },
      costcent: { total: 0, rows: [], loading: false, finish: false },
      codbrlc: { total: 0, rows: [], loading: false, finish: false },
      codtency: { total: 0, rows: [], loading: false, finish: false },
      codedlv: { total: 0, rows: [], loading: false, finish: false },
      codjob: { total: 0, rows: [], loading: false, finish: false },
      codempmt: { total: 0, rows: [], loading: false, finish: false },
      typemp: { total: 0, rows: [], loading: false, finish: false },
      typpayroll: { total: 0, rows: [], loading: false, finish: false },
      codinst: { total: 0, rows: [], loading: false, finish: false },
      staemp: { total: 0, rows: [], loading: false, finish: false },
      coddomcl: { total: 0, rows: [], loading: false, finish: false },
      codprovr: { total: 0, rows: [], loading: false, finish: false },
      typleave: { total: 0, rows: [], loading: false, finish: false },
      courstrain: { total: 0, rows: [], loading: false, finish: false },
      codempstapp: { total: 0, rows: [], loading: false, finish: false },
      lang: window.localStorage.getItem(env.site + '_lang')
    },
    popupLovTitle: {
      codempid: 'List of Employee',
      codemp9: 'List of Employee',
      codpos: 'List of Position',
      codapp: 'List of Application',
      nummemo: 'List of Memo',
      codcours: 'List of Course',
      codform: 'List of Form',
      numappl: 'List of Application Number',
      numreq: 'List of Request',
      codaplvl: 'List of Appraisal Group',
      grdscor: 'List of Grade Score',
      grditem: 'List of Grade Score',
      codappr: 'List of Approval',
      codshift: 'List of Shift',
      codroom: 'List of Room',
      codasset: 'List of Asset',
      codcalen: 'List of Group',
      codcompy: 'List of Company',
      batchno: 'List of Batch No',
      costcent: 'List of Cost Center',
      codbrlc: 'List of Work Location Code',
      codtency: 'Type of Special Skills/Exp.',
      codedlv: 'List Of Education Code',
      codjob: 'List Of Job',
      codempmt: 'List Of Employment Type',
      typemp: 'List Of Employee Type',
      typpayroll: 'List Of Payroll Code',
      codinst: 'List Of Institute Code',
      staemp: 'List of Employee status',
      coddomcl: 'List Place of birth',
      codprovr: 'List of Province',
      typleave: 'List of Type of Leave',
      courstrain: 'List of Course',
      codempstapp: 'List of Employee'
    },
    lovCurrentDesc: function (type, code) {
      let rowIndex = this.$store.getters[types.GET_LOV][type].rows.map(function (lov) {
        return lov[type]
      }).indexOf(code)
      if (rowIndex >= 0) {
        if (typeof this.$store.getters[types.GET_LOV][type].rows[rowIndex] !== 'undefined') {
          return this.$store.getters[types.GET_LOV][type].rows[rowIndex]['desc_' + type]
        }
      }
      return ''
    },
    columnsLabelsCalled: false,
    popupLovLabels: hrmsLovLabels,
    popupLovColumns: hrmsLovColumns()
  },
  getters: {
    [types.GET_LOV_COLUMNS] (state) {
      return state.popupLovColumns
    },
    [types.GET_LOV_LABELS] (state) {
      return state.popupLovLabels
    },
    [types.GET_LOV] (state) {
      return state.popupLov
    },
    [types.GET_LOV_TITLE] (state) {
      return state.popupLovTitle
    },
    [types.GET_LOV_CURRENT_DESC] (state) {
      return state.lovCurrentDesc
    }
  },
  mutations: {
    [types.SET_LOV_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.popupLovColumns[keyLang].codempid = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codempid, labels[keyLang])
        state.popupLovColumns[keyLang].codemp9 = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codemp9, labels[keyLang])
        state.popupLovColumns[keyLang].codpos = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codpos, labels[keyLang])
        state.popupLovColumns[keyLang].codapp = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codapp, labels[keyLang])
        state.popupLovColumns[keyLang].nummemo = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].nummemo, labels[keyLang])
        state.popupLovColumns[keyLang].codcours = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codcours, labels[keyLang])
        state.popupLovColumns[keyLang].codform = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codform, labels[keyLang])
        state.popupLovColumns[keyLang].numappl = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].numappl, labels[keyLang])
        state.popupLovColumns[keyLang].numreq = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].numreq, labels[keyLang])
        state.popupLovColumns[keyLang].codaplvl = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codaplvl, labels[keyLang])
        state.popupLovColumns[keyLang].grdscor = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].grdscor, labels[keyLang])
        state.popupLovColumns[keyLang].grditem = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].grditem, labels[keyLang])
        state.popupLovColumns[keyLang].codshift = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codshift, labels[keyLang])
        state.popupLovColumns[keyLang].codroom = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codroom, labels[keyLang])
        state.popupLovColumns[keyLang].codasset = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codasset, labels[keyLang])
        state.popupLovColumns[keyLang].codcalen = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codcalen, labels[keyLang])
        state.popupLovColumns[keyLang].batchno = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].batchno, labels[keyLang])
        state.popupLovColumns[keyLang].costcent = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].costcent, labels[keyLang])
        state.popupLovColumns[keyLang].codbrlc = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codbrlc, labels[keyLang])
        state.popupLovColumns[keyLang].codtency = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codtency, labels[keyLang])
        state.popupLovColumns[keyLang].codedlv = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codedlv, labels[keyLang])
        state.popupLovColumns[keyLang].codjob = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codjob, labels[keyLang])
        state.popupLovColumns[keyLang].codempmt = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codempmt, labels[keyLang])
        state.popupLovColumns[keyLang].typemp = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].typemp, labels[keyLang])
        state.popupLovColumns[keyLang].typpayroll = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].typpayroll, labels[keyLang])
        state.popupLovColumns[keyLang].codinst = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codinst, labels[keyLang])
        state.popupLovColumns[keyLang].staemp = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].staemp, labels[keyLang])
        state.popupLovColumns[keyLang].coddomcl = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].coddomcl, labels[keyLang])
        state.popupLovColumns[keyLang].codprovr = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codprovr, labels[keyLang])
        state.popupLovColumns[keyLang].typleave = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].typleave, labels[keyLang])
        state.popupLovColumns[keyLang].courstrain = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].courstrain, labels[keyLang])
        state.popupLovColumns[keyLang].codempstapp = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codempstapp, labels[keyLang])
        // state.popupLovColumns[keyLang].codappr = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codappr, labels[keyLang])
        // state.popupLovColumns[keyLang].codcompy = configLabel.replaceLabelToColumns(state.popupLovColumns[keyLang].codcompy, labels[keyLang])
      }
    },
    [types.SET_LOV_LABELS] (state, labels) {
      state.popupLovLabels = labels
    },
    [types.SET_LOV_COLUMNS_LABELS_CALLED] (state, columnsLabelsCalled) {
      state.columnsLabelsCalled = columnsLabelsCalled
    },
    [types.SET_LOV_CODEMPID] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codempid = lov.namempe
            break
          case 'th':
            popupLov.rows[i].desc_codempid = lov.namempt
            break
          case '103':
            popupLov.rows[i].desc_codempid = lov.namemp3
            break
          case '104':
            popupLov.rows[i].desc_codempid = lov.namemp4
            break
          case '105':
            popupLov.rows[i].desc_codempid = lov.namemp5
            break
        }
      }
      state.popupLov.codempid = popupLov
    },
    [types.SET_LOV_CODEMP9] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codemp9 = lov.namempe
            break
          case 'th':
            popupLov.rows[i].desc_codemp9 = lov.namempt
            break
          case '103':
            popupLov.rows[i].desc_codemp9 = lov.namemp3
            break
          case '104':
            popupLov.rows[i].desc_codemp9 = lov.namemp4
            break
          case '105':
            popupLov.rows[i].desc_codemp9 = lov.namemp5
            break
        }
      }
      state.popupLov.codemp9 = popupLov
    },
    [types.SET_LOV_CODPOS] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codpos = lov.nampose
            break
          case 'th':
            popupLov.rows[i].desc_codpos = lov.nampost
            break
          case '103':
            popupLov.rows[i].desc_codpos = lov.nampos3
            break
          case '104':
            popupLov.rows[i].desc_codpos = lov.nampos4
            break
          case '105':
            popupLov.rows[i].desc_codpos = lov.nampos5
            break
        }
      }
      state.popupLov.codpos = popupLov
    },
    [types.SET_LOV_CODAPP] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codapp = lov.namappe
            break
          case 'th':
            popupLov.rows[i].desc_codapp = lov.namappt
            break
          case '103':
            popupLov.rows[i].desc_codapp = lov.namapp3
            break
          case '104':
            popupLov.rows[i].desc_codapp = lov.namapp4
            break
          case '105':
            popupLov.rows[i].desc_codapp = lov.namapp5
            break
        }
      }
      state.popupLov.codapp = popupLov
    },
    [types.SET_LOV_NUMMEMO] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].dtemonth = configLabel.month['en'][parseInt(lov.dtemonth) - 1].full
            popupLov.rows[i].namcours = lov.namcourse
            break
          case 'th':
            popupLov.rows[i].dtemonth = configLabel.month['th'][parseInt(lov.dtemonth) - 1].full
            popupLov.rows[i].namcours = lov.namcourst
            break
          case '103':
            popupLov.rows[i].dtemonth = configLabel.month['103'][parseInt(lov.dtemonth) - 1].full
            popupLov.rows[i].namcours = lov.namcours3
            break
          case '104':
            popupLov.rows[i].dtemonth = configLabel.month['104'][parseInt(lov.dtemonth) - 1].full
            popupLov.rows[i].namcours = lov.namcours4
            break
          case '105':
            popupLov.rows[i].dtemonth = configLabel.month['105'][parseInt(lov.dtemonth) - 1].full
            popupLov.rows[i].namcours = lov.namcours5
            break
        }
      }
      state.popupLov.nummemo = popupLov
    },
    [types.SET_LOV_CODCOURS] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codcours = lov.namcourse
            break
          case 'th':
            popupLov.rows[i].desc_codcours = lov.namcourst
            break
          case '103':
            popupLov.rows[i].desc_codcours = lov.namcours3
            break
          case '104':
            popupLov.rows[i].desc_codcours = lov.namcours4
            break
          case '105':
            popupLov.rows[i].desc_codcours = lov.namcours5
            break
        }
      }
      state.popupLov.codcours = popupLov
    },
    [types.SET_LOV_CODFORM] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codform = lov.desforme
            break
          case 'th':
            popupLov.rows[i].desc_codform = lov.desformt
            break
          case '103':
            popupLov.rows[i].desc_codform = lov.desform3
            break
          case '104':
            popupLov.rows[i].desc_codform = lov.desform4
            break
          case '105':
            popupLov.rows[i].desc_codform = lov.desform5
            break
        }
      }
      state.popupLov.codform = popupLov
    },
    [types.SET_LOV_NUMAPPL] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_numappl = lov.desapple
            break
          case 'th':
            popupLov.rows[i].desc_numappl = lov.desapplt
            break
          case '103':
            popupLov.rows[i].desc_numappl = lov.desappl3
            break
          case '104':
            popupLov.rows[i].desc_numappl = lov.desappl4
            break
          case '105':
            popupLov.rows[i].desc_numappl = lov.desappl5
            break
        }
      }
      state.popupLov.numappl = popupLov
    },
    [types.SET_LOV_NUMREQ] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codpos = lov.nampose
            break
          case 'th':
            popupLov.rows[i].desc_codpos = lov.nampost
            break
          case '103':
            popupLov.rows[i].desc_codpos = lov.nampos3
            break
          case '104':
            popupLov.rows[i].desc_codpos = lov.nampos4
            break
          case '105':
            popupLov.rows[i].desc_codpos = lov.nampos5
            break
        }
        popupLov.rows[i].desc_numreq = lov.numreq
      }
      state.popupLov.numreq = popupLov
    },
    [types.SET_LOV_APLV] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codaplvl = lov.descode
            break
          case 'th':
            popupLov.rows[i].desc_codaplvl = lov.descodt
            break
          case '103':
            popupLov.rows[i].desc_codaplvl = lov.descod3
            break
          case '104':
            popupLov.rows[i].desc_codaplvl = lov.descod4
            break
          case '105':
            popupLov.rows[i].desc_codaplvl = lov.descod5
            break
        }
      }
      state.popupLov.codaplvl = popupLov
    },
    [types.SET_LOV_GRDSCOR] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        popupLov.rows[i].desc_grdscor = lov.achieve
      }
      state.popupLov.grdscor = popupLov
    },
    [types.SET_LOV_GRDITEM] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        popupLov.rows[i].desc_grditem = lov.achieve
      }
      state.popupLov.grditem = popupLov
    },
    [types.SET_LOV_CODAPPR] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codempid = lov.namempe
            break
          case 'th':
            popupLov.rows[i].desc_codempid = lov.namempt
            break
          case '103':
            popupLov.rows[i].desc_codempid = lov.namemp3
            break
          case '104':
            popupLov.rows[i].desc_codempid = lov.namemp4
            break
          case '105':
            popupLov.rows[i].desc_codempid = lov.namemp5
            break
        }
      }
      state.popupLov.codappr = popupLov
    },
    [types.SET_LOV_CODCALEN] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codcalen = lov.descalene
            break
          case 'th':
            popupLov.rows[i].desc_codcalen = lov.descalent
            break
          case '103':
            popupLov.rows[i].desc_codcalen = lov.descalen3
            break
          case '104':
            popupLov.rows[i].desc_codcalen = lov.descalen4
            break
          case '105':
            popupLov.rows[i].desc_codcalen = lov.descalen5
            break
        }
      }
      state.popupLov.codcalen = popupLov
    },
    [types.SET_LOV_CODCOMPY] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codcompy = lov.descompye
            break
          case 'th':
            popupLov.rows[i].desc_codcompy = lov.descompyt
            break
          case '103':
            popupLov.rows[i].desc_codcompy = lov.descompy3
            break
          case '104':
            popupLov.rows[i].desc_codcompy = lov.descompy4
            break
          case '105':
            popupLov.rows[i].desc_codcompy = lov.descompy5
            break
        }
      }
      state.popupLov.codcompy = popupLov
    },
    [types.SET_LOV_CODSHIFT] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codshift = lov.desshifte
            break
          case 'th':
            popupLov.rows[i].desc_codshift = lov.desshiftt
            break
          case '103':
            popupLov.rows[i].desc_codshift = lov.desshift3
            break
          case '104':
            popupLov.rows[i].desc_codshift = lov.desshift4
            break
          case '105':
            popupLov.rows[i].desc_codshift = lov.desshift5
            break
        }
      }
      state.popupLov.codshift = popupLov
    },
    [types.SET_LOV_CODROOM] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codroom = lov.roomname
            break
          case 'th':
            popupLov.rows[i].desc_codroom = lov.roomnamt
            break
          case '103':
            popupLov.rows[i].desc_codroom = lov.roomnam3
            break
          case '104':
            popupLov.rows[i].desc_codroom = lov.roomnam4
            break
          case '105':
            popupLov.rows[i].desc_codroom = lov.roomnam5
            break
        }
      }
      state.popupLov.codroom = popupLov
    },
    [types.SET_LOV_CODASSET] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codasset = lov.desassee
            break
          case 'th':
            popupLov.rows[i].desc_codasset = lov.desasset
            break
          case '103':
            popupLov.rows[i].desc_codasset = lov.desasse3
            break
          case '104':
            popupLov.rows[i].desc_codasset = lov.desasse4
            break
          case '105':
            popupLov.rows[i].desc_codasset = lov.desasse5
            break
        }
      }
      state.popupLov.codasset = popupLov
    },
    [types.SET_LOV_BATCH] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].lastseq = lov.lastseq
            break
        }
      }
      state.popupLov.batchno = popupLov
    },
    [types.SET_LOV_COSTCENT] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_costcent = lov.descostcente
            break
          case 'th':
            popupLov.rows[i].desc_costcent = lov.descostcentt
            break
          case '103':
            popupLov.rows[i].desc_costcent = lov.descostcent3
            break
          case '104':
            popupLov.rows[i].desc_costcent = lov.descostcent4
            break
          case '105':
            popupLov.rows[i].desc_costcent = lov.descostcent5
            break
        }
      }
      state.popupLov.costcent = popupLov
    },
    [types.SET_LOV_CODBRLC] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codbrlc = lov.descodbrlce
            break
          case 'th':
            popupLov.rows[i].desc_codbrlc = lov.descodbrlct
            break
          case '103':
            popupLov.rows[i].desc_codbrlc = lov.descodbrlc3
            break
          case '104':
            popupLov.rows[i].desc_codbrlc = lov.descodbrlc4
            break
          case '105':
            popupLov.rows[i].desc_codbrlc = lov.descodbrlc5
            break
        }
      }
      state.popupLov.codbrlc = popupLov
    },
    [types.SET_LOV_CODTENCY] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codtency = lov.descodtencye
            break
          case 'th':
            popupLov.rows[i].desc_codtency = lov.descodtencyt
            break
          case '103':
            popupLov.rows[i].desc_codtency = lov.descodtency3
            break
          case '104':
            popupLov.rows[i].desc_codtency = lov.descodtency4
            break
          case '105':
            popupLov.rows[i].desc_codtency = lov.descodtency5
            break
        }
      }
      state.popupLov.codtency = popupLov
    },
    [types.SET_LOV_CODEDLV] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codedlv = lov.descodedlve
            break
          case 'th':
            popupLov.rows[i].desc_codedlv = lov.descodedlvt
            break
          case '103':
            popupLov.rows[i].desc_codedlv = lov.descodedlv3
            break
          case '104':
            popupLov.rows[i].desc_codedlv = lov.descodedlv4
            break
          case '105':
            popupLov.rows[i].desc_codedlv = lov.descodedlv5
            break
        }
      }
      state.popupLov.codedlv = popupLov
    },
    [types.SET_LOV_CODJOB] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codjob = lov.descodjobe
            break
          case 'th':
            popupLov.rows[i].desc_codjob = lov.descodjobt
            break
          case '103':
            popupLov.rows[i].desc_codjob = lov.descodjob3
            break
          case '104':
            popupLov.rows[i].desc_codjob = lov.descodjob4
            break
          case '105':
            popupLov.rows[i].desc_codjob = lov.descodjob5
            break
        }
      }
      state.popupLov.codjob = popupLov
    },
    [types.SET_LOV_CODEMPMT] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codempmt = lov.descodempmte
            break
          case 'th':
            popupLov.rows[i].desc_codempmt = lov.descodempmtt
            break
          case '103':
            popupLov.rows[i].desc_codempmt = lov.descodempmt3
            break
          case '104':
            popupLov.rows[i].desc_codempmt = lov.descodempmt4
            break
          case '105':
            popupLov.rows[i].desc_codempmt = lov.descodempmt5
            break
        }
      }
      state.popupLov.codempmt = popupLov
    },
    [types.SET_LOV_TYPEMP] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_typemp = lov.destypempe
            break
          case 'th':
            popupLov.rows[i].desc_typemp = lov.destypempt
            break
          case '103':
            popupLov.rows[i].desc_typemp = lov.destypemp3
            break
          case '104':
            popupLov.rows[i].desc_typemp = lov.destypemp4
            break
          case '105':
            popupLov.rows[i].desc_typemp = lov.destypemp5
            break
        }
      }
      state.popupLov.typemp = popupLov
    },
    [types.SET_LOV_TYPPAYROLL] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_typpayroll = lov.destyppayrolle
            break
          case 'th':
            popupLov.rows[i].desc_typpayroll = lov.destyppayrollt
            break
          case '103':
            popupLov.rows[i].desc_typpayroll = lov.destyppayroll3
            break
          case '104':
            popupLov.rows[i].desc_typpayroll = lov.destyppayroll4
            break
          case '105':
            popupLov.rows[i].desc_typpayroll = lov.destyppayroll5
            break
        }
      }
      state.popupLov.typpayroll = popupLov
    },
    [types.SET_LOV_CODINST] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codinst = lov.descodinste
            break
          case 'th':
            popupLov.rows[i].desc_codinst = lov.descodinstt
            break
          case '103':
            popupLov.rows[i].desc_codinst = lov.descodinst3
            break
          case '104':
            popupLov.rows[i].desc_codinst = lov.descodinst4
            break
          case '105':
            popupLov.rows[i].desc_codinst = lov.descodinst5
            break
        }
      }
      state.popupLov.codinst = popupLov
    },
    [types.SET_LOV_STAEMP] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_staemp = lov.desstaempe
            break
          case 'th':
            popupLov.rows[i].desc_staemp = lov.desstaempt
            break
          case '103':
            popupLov.rows[i].desc_staemp = lov.desstaemp3
            break
          case '104':
            popupLov.rows[i].desc_staemp = lov.desstaemp4
            break
          case '105':
            popupLov.rows[i].desc_staemp = lov.desstaemp5
            break
        }
      }
      state.popupLov.staemp = popupLov
    },
    [types.SET_LOV_CODSEX] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codsex = lov.descodsexe
            break
          case 'th':
            popupLov.rows[i].desc_codsex = lov.descodsext
            break
          case '103':
            popupLov.rows[i].desc_codsex = lov.descodsex3
            break
          case '104':
            popupLov.rows[i].desc_codsex = lov.descodsex4
            break
          case '105':
            popupLov.rows[i].desc_codsex = lov.descodsex5
            break
        }
      }
      state.popupLov.codsex = popupLov
    },
    [types.SET_LOV_CODDOMCL] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_coddomcl = lov.descoddomcle
            break
          case 'th':
            popupLov.rows[i].desc_coddomcl = lov.descoddomclt
            break
          case '103':
            popupLov.rows[i].desc_coddomcl = lov.descoddomcl3
            break
          case '104':
            popupLov.rows[i].desc_coddomcl = lov.descoddomcl4
            break
          case '105':
            popupLov.rows[i].desc_coddomcl = lov.descoddomcl5
            break
        }
      }
      state.popupLov.coddomcl = popupLov
    },
    [types.SET_LOV_CODPROVR] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codprovr = lov.descodprovre
            break
          case 'th':
            popupLov.rows[i].desc_codprovr = lov.descodprovrt
            break
          case '103':
            popupLov.rows[i].desc_codprovr = lov.descodprovr3
            break
          case '104':
            popupLov.rows[i].desc_codprovr = lov.descodprovr4
            break
          case '105':
            popupLov.rows[i].desc_codprovr = lov.descodprovr5
            break
        }
      }
      state.popupLov.codprovr = popupLov
    },
    [types.SET_LOV_TYPLEAVE] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_typleave = lov.destypleavee
            break
          case 'th':
            popupLov.rows[i].desc_typleave = lov.destypleavet
            break
          case '103':
            popupLov.rows[i].desc_typleave = lov.destypleave3
            break
          case '104':
            popupLov.rows[i].desc_typleave = lov.destypleave4
            break
          case '105':
            popupLov.rows[i].desc_typleave = lov.destypleave5
            break
        }
      }
      state.popupLov.typleave = popupLov
    },
    [types.SET_LOV_COURSTRAIN] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_courstrain = lov.descourstraine
            break
          case 'th':
            popupLov.rows[i].desc_courstrain = lov.descourstraint
            break
          case '103':
            popupLov.rows[i].desc_courstrain = lov.descourstrain3
            break
          case '104':
            popupLov.rows[i].desc_courstrain = lov.descourstrain4
            break
          case '105':
            popupLov.rows[i].desc_courstrain = lov.descourstrain5
            break
        }
      }
      state.popupLov.courstrain = popupLov
    },
    [types.SET_LOV_CODEMPSTAPP] (state, popupLov) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLov.lang = nowLang
      for (var i = 0; i < popupLov.rows.length; i++) {
        let lov = popupLov.rows[i]
        switch (nowLang) {
          case 'en':
            popupLov.rows[i].desc_codempstapp = lov.namempe
            break
          case 'th':
            popupLov.rows[i].desc_codempstapp = lov.namempt
            break
          case '103':
            popupLov.rows[i].desc_codempstapp = lov.namemp3
            break
          case '104':
            popupLov.rows[i].desc_codempstapp = lov.namemp4
            break
          case '105':
            popupLov.rows[i].desc_codempstapp = lov.namemp5
            break
        }
      }
      state.popupLov.codempstapp = popupLov
    }
  },
  actions: {
    [types.RECEIVED_LOV_COLUMNS_LABELS] ({ state, commit }, lovType) {
      if (!state.columnsLabelsCalled) {
        commit(types.SET_LOV_COLUMNS_LABELS_CALLED, true)
        hrmsLov.getLovLabels()
          .then((response) => {
            const data = JSON.parse(response.request.response)
            commit(types.SET_LOV_COLUMNS, data.labels)
            commit(types.SET_LOV_LABELS, data.labels)
          })
          .catch((error) => {
            let message = error
            if (error.response) {
              const data = error.response.data
              message = data.response
            }
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          })
      }
    },
    [types.RECEIVED_LOV] ({ state, commit }, { lovType, params }) {
      switch (lovType.toUpperCase()) {
        case 'CODEMPID':
          if (!state.popupLov.codempid.finish) {
            if (!state.popupLov.codempid.loading) {
              commit(types.SET_LOV_CODEMPID, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodempid()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODEMPID, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODEMPID, { total: state.popupLov.codempid.total, rows: state.popupLov.codempid.rows, loading: false, finish: true })
          }
          break
        case 'CODEMP9':
          if (!state.popupLov.codemp9.finish) {
            if (!state.popupLov.codemp9.loading) {
              commit(types.SET_LOV_CODEMP9, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodempid9()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODEMP9, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODEMP9, { total: state.popupLov.codemp9.total, rows: state.popupLov.codemp9.rows, loading: false, finish: true })
          }
          break
        case 'CODPOS':
          if (!state.popupLov.codpos.finish) {
            if (!state.popupLov.codpos.loading) {
              commit(types.SET_LOV_CODPOS, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodpos()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODPOS, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODPOS, { total: state.popupLov.codpos.total, rows: state.popupLov.codpos.rows, loading: false, finish: true })
          }
          break
        case 'CODAPP':
          if (!state.popupLov.codapp.finish) {
            if (!state.popupLov.codapp.loading) {
              commit(types.SET_LOV_CODAPP, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodapp()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODAPP, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODAPP, { total: state.popupLov.codapp.total, rows: state.popupLov.codapp.rows, loading: false, finish: true })
          }
          break
        case 'NUMMEMO':
          if (!state.popupLov.nummemo.finish) {
            if (!state.popupLov.nummemo.loading) {
              commit(types.SET_LOV_NUMMEMO, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovNummemo()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_NUMMEMO, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_NUMMEMO, { total: state.popupLov.nummemo.total, rows: state.popupLov.nummemo.rows, loading: false, finish: true })
          }
          break
        case 'CODCOURS':
          if (!state.popupLov.codcours.finish) {
            if (!state.popupLov.codcours.loading) {
              commit(types.SET_LOV_CODCOURS, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodcours()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODCOURS, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODCOURS, { total: state.popupLov.codcours.total, rows: state.popupLov.codcours.rows, loading: false, finish: true })
          }
          break
        case 'CODFORM':
          if (!state.popupLov.codform.finish) {
            if (!state.popupLov.codform.loading) {
              commit(types.SET_LOV_CODFORM, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodform()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODFORM, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODFORM, { total: state.popupLov.codform.total, rows: state.popupLov.codform.rows, loading: false, finish: true })
          }
          break
        case 'NUMAPPL':
          if (!state.popupLov.numappl.finish) {
            if (!state.popupLov.numappl.loading) {
              commit(types.SET_LOV_NUMAPPL, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovNumappl()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_NUMAPPL, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_NUMAPPL, { total: state.popupLov.numappl.total, rows: state.popupLov.numappl.rows, loading: false, finish: true })
          }
          break
        case 'NUMREQ':
          if (!state.popupLov.numreq.finish) {
            if (!state.popupLov.numreq.loading) {
              commit(types.SET_LOV_NUMREQ, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovNumreq()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_NUMREQ, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_NUMREQ, { total: state.popupLov.numreq.total, rows: state.popupLov.numreq.rows, loading: false, finish: true })
          }
          break
        case 'CODAPLVL':
          if (!state.popupLov.codaplvl.finish) {
            if (!state.popupLov.codaplvl.loading) {
              commit(types.SET_LOV_APLV, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodaplvl()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_APLV, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_APLV, { total: state.popupLov.codaplvl.total, rows: state.popupLov.codaplvl.rows, loading: false, finish: true })
          }
          break
        case 'GRDSCOR':
          // if (!state.popupLov.grdscor.finish) {
          if (!state.popupLov.grdscor.loading) {
            commit(types.SET_LOV_GRDSCOR, { total: 0, rows: [], loading: true, finish: false })
            hrmsLov.getLovGrdscor(params)
              .then((response) => {
                const data = JSON.parse(response.request.response)
                commit(types.SET_LOV_GRDSCOR, { total: data.total, rows: data.rows, loading: false, finish: true })
              })
              .catch((error) => {
                let message = error
                if (error.response) {
                  const data = error.response.data
                  message = data.response
                }
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              })
          }
          // } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
          //   commit(types.SET_LOV_GRDSCOR, { total: state.popupLov.grdscor.total, rows: state.popupLov.grdscor.rows, loading: false, finish: true })
          // }
          break
        case 'GRDITEM':
          // if (!state.popupLov.grditem.finish) {
          if (!state.popupLov.grditem.loading && typeof params !== 'undefined') {
            commit(types.SET_LOV_GRDITEM, { total: 0, rows: [], loading: true, finish: false })
            hrmsLov.getLovGrdscor(params)
              .then((response) => {
                const data = JSON.parse(response.request.response)
                commit(types.SET_LOV_GRDITEM, { total: data.total, rows: data.rows, loading: false, finish: true })
              })
              .catch((error) => {
                let message = error
                if (error.response) {
                  const data = error.response.data
                  message = data.response
                }
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              })
          }
          // } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
          //   commit(types.SET_LOV_GRDSCOR, { total: state.popupLov.grditem.total, rows: state.popupLov.grditem.rows, loading: false, finish: true })
          // }
          break
        case 'CODAPPR':
          if (!state.popupLov.codappr.finish) {
            if (!state.popupLov.codappr.loading) {
              commit(types.SET_LOV_CODAPPR, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodappr()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODAPPR, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODAPPR, { total: state.popupLov.codappr.total, rows: state.popupLov.codappr.rows, loading: false, finish: true })
          }
          break
        case 'CODCALEN':
          if (!state.popupLov.codcalen.finish) {
            if (!state.popupLov.codcalen.loading) {
              commit(types.SET_LOV_CODCALEN, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodcalen()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODCALEN, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODCALEN, { total: state.popupLov.codcalen.total, rows: state.popupLov.codcalen.rows, loading: false, finish: true })
          }
          break
        case 'CODSHIFT':
          if (!state.popupLov.codshift.finish) {
            if (!state.popupLov.codshift.loading) {
              commit(types.SET_LOV_CODSHIFT, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodshift()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODSHIFT, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODSHIFT, { total: state.popupLov.codshift.total, rows: state.popupLov.codshift.rows, loading: false, finish: true })
          }
          break
        case 'CODROOM':
          if (!state.popupLov.codroom.finish) {
            if (!state.popupLov.codroom.loading) {
              commit(types.SET_LOV_CODROOM, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodroom()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODROOM, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODROOM, { total: state.popupLov.codroom.total, rows: state.popupLov.codroom.rows, loading: false, finish: true })
          }
          break
        case 'CODASSET':
          if (!state.popupLov.codasset.finish) {
            if (!state.popupLov.codasset.loading) {
              commit(types.SET_LOV_CODASSET, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodasset()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODASSET, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODASSET, { total: state.popupLov.codasset.total, rows: state.popupLov.codasset.rows, loading: false, finish: true })
          }
          break
        case 'CODCOMPY':
          if (!state.popupLov.codcompy.finish) {
            if (!state.popupLov.codcompy.loading) {
              commit(types.SET_LOV_CODCOMPY, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodcompy()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODCOMPY, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODCOMPY, { total: state.popupLov.codcompy.total, rows: state.popupLov.codcompy.rows, loading: false, finish: true })
          }
          break
        case 'BATCHNO':
          if (!state.popupLov.batchno.finish) {
            if (!state.popupLov.batchno.loading) {
              commit(types.SET_LOV_BATCH, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovBatchno()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_BATCH, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_BATCH, { total: state.popupLov.batchno.total, rows: state.popupLov.batchno.rows, loading: false, finish: true })
          }
          break
        case 'COSTCENT':
          if (!state.popupLov.costcent.finish) {
            if (!state.popupLov.costcent.loading) {
              commit(types.SET_LOV_COSTCENT, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCostcent()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_COSTCENT, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_COSTCENT, { total: state.popupLov.costcent.total, rows: state.popupLov.costcent.rows, loading: false, finish: true })
          }
          break
        case 'CODBRLC':
          if (!state.popupLov.codbrlc.finish) {
            if (!state.popupLov.codbrlc.loading) {
              commit(types.SET_LOV_CODBRLC, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodbrlc()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODBRLC, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODBRLC, { total: state.popupLov.codbrlc.total, rows: state.popupLov.codbrlc.rows, loading: false, finish: true })
          }
          break
        case 'CODTENCY':
          if (!state.popupLov.codtency.finish) {
            if (!state.popupLov.codtency.loading) {
              commit(types.SET_LOV_CODTENCY, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodtency()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODTENCY, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODTENCY, { total: state.popupLov.codtency.total, rows: state.popupLov.codtency.rows, loading: false, finish: true })
          }
          break
        case 'CODEDLV':
          if (!state.popupLov.codedlv.finish) {
            if (!state.popupLov.codedlv.loading) {
              commit(types.SET_LOV_CODEDLV, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodedlv()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODEDLV, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODEDLV, { total: state.popupLov.codedlv.total, rows: state.popupLov.codedlv.rows, loading: false, finish: true })
          }
          break
        case 'CODJOB':
          if (!state.popupLov.codjob.finish) {
            if (!state.popupLov.codjob.loading) {
              commit(types.SET_LOV_CODJOB, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodjob()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODJOB, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODJOB, { total: state.popupLov.codjob.total, rows: state.popupLov.codjob.rows, loading: false, finish: true })
          }
          break
        case 'CODEMPMT':
          if (!state.popupLov.codempmt.finish) {
            if (!state.popupLov.codempmt.loading) {
              commit(types.SET_LOV_CODEMPMT, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodempmt()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODEMPMT, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODEMPMT, { total: state.popupLov.codempmt.total, rows: state.popupLov.codempmt.rows, loading: false, finish: true })
          }
          break
        case 'TYPEMP':
          if (!state.popupLov.typemp.finish) {
            if (!state.popupLov.typemp.loading) {
              commit(types.SET_LOV_TYPEMP, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovTypemp()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_TYPEMP, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_TYPEMP, { total: state.popupLov.typemp.total, rows: state.popupLov.typemp.rows, loading: false, finish: true })
          }
          break
        case 'TYPPAYROLL':
          if (!state.popupLov.typpayroll.finish) {
            if (!state.popupLov.typpayroll.loading) {
              commit(types.SET_LOV_TYPPAYROLL, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovTyppayroll()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_TYPPAYROLL, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_TYPPAYROLL, { total: state.popupLov.typpayroll.total, rows: state.popupLov.typpayroll.rows, loading: false, finish: true })
          }
          break
        case 'CODINST':
          if (!state.popupLov.codinst.finish) {
            if (!state.popupLov.codinst.loading) {
              commit(types.SET_LOV_CODINST, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodinst()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODINST, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODINST, { total: state.popupLov.codinst.total, rows: state.popupLov.codinst.rows, loading: false, finish: true })
          }
          break
        case 'STAEMP':
          if (!state.popupLov.staemp.finish) {
            if (!state.popupLov.staemp.loading) {
              commit(types.SET_LOV_STAEMP, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovStaemp()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_STAEMP, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_STAEMP, { total: state.popupLov.staemp.total, rows: state.popupLov.staemp.rows, loading: false, finish: true })
          }
          break
        case 'CODDOMCL':
          if (!state.popupLov.coddomcl.finish) {
            if (!state.popupLov.coddomcl.loading) {
              commit(types.SET_LOV_CODDOMCL, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCoddomcl()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODDOMCL, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODDOMCL, { total: state.popupLov.coddomcl.total, rows: state.popupLov.coddomcl.rows, loading: false, finish: true })
          }
          break
        case 'CODPROVR':
          if (!state.popupLov.codprovr.finish) {
            if (!state.popupLov.codprovr.loading) {
              commit(types.SET_LOV_CODPROVR, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodprovr()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODPROVR, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODPROVR, { total: state.popupLov.codprovr.total, rows: state.popupLov.codprovr.rows, loading: false, finish: true })
          }
          break
        case 'TYPLEAVE':
          if (!state.popupLov.typleave.finish) {
            if (!state.popupLov.typleave.loading) {
              commit(types.SET_LOV_TYPLEAVE, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovTypleave()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_TYPLEAVE, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_TYPLEAVE, { total: state.popupLov.typleave.total, rows: state.popupLov.typleave.rows, loading: false, finish: true })
          }
          break
        case 'COURSTRAIN':
          // if (!state.popupLov.courstrain.finish) {
          if (!state.popupLov.courstrain.loading) {
            commit(types.SET_LOV_COURSTRAIN, { total: 0, rows: [], loading: true, finish: false })
            hrmsLov.getLovCoursTrain(params)
              .then((response) => {
                const data = JSON.parse(response.request.response)
                commit(types.SET_LOV_COURSTRAIN, { total: data.total, rows: data.rows, loading: false, finish: true })
              })
              .catch((error) => {
                let message = error
                if (error.response) {
                  const data = error.response.data
                  message = data.response
                }
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              })
          }
          // } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
          //   commit(types.SET_LOV_COURSTRAIN, { total: state.popupLov.courstrain.total, rows: state.popupLov.courstrain.rows, loading: false, finish: true })
          // }
          break
        case 'CODEMPSTAPP':
          if (!state.popupLov.codempstapp.finish) {
            if (!state.popupLov.codempstapp.loading) {
              commit(types.SET_LOV_CODEMPSTAPP, { total: 0, rows: [], loading: true, finish: false })
              hrmsLov.getLovCodempstapp()
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  commit(types.SET_LOV_CODEMPSTAPP, { total: data.total, rows: data.rows, loading: false, finish: true })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  swal({
                    title: '', text: message, html: true, type: 'error'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
            }
          } else if (state.popupLov.lang !== window.localStorage.getItem(env.site + '_lang')) {
            commit(types.SET_LOV_CODEMPSTAPP, { total: state.popupLov.codempstapp.total, rows: state.popupLov.codempstapp.rows, loading: false, finish: true })
          }
          break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrmsLov/index.js